
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/t-cs",
      function () {
        return require("private-next-pages/t-cs.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/t-cs"])
      });
    }
  